/* Genius Distributor Form — multistep wizard + submission */
(function () {
  'use strict';
  var root = document.getElementById('acg-distributor-form');
  if (!root) return;

  var form = root.querySelector('.acg-df-form');
  var endpoint = root.dataset.endpoint;
  var steps = Array.prototype.slice.call(form.querySelectorAll('.acg-df-step'));
  var progress = Array.prototype.slice.call(root.querySelectorAll('.acg-df-progress-item'));
  var backBtn = form.querySelector('.acg-df-back');
  var nextBtn = form.querySelector('.acg-df-next');
  var submitBtn = form.querySelector('.acg-df-submit');
  var successPanel = root.querySelector('.acg-df-success');
  var errorPanel = root.querySelector('.acg-df-error');
  var MAX_FILE = 10 * 1024 * 1024;
  var current = 0;

  // ---- Language toggle (EN / ES) ----
  var langButtons = Array.prototype.slice.call(root.querySelectorAll('.acg-df-lang-btn'));
  var localeInput = form.querySelector('input[name="locale"]');
  var lang = 'en';
  var I18N = {
    en: { submitting: 'Submitting…', submit: 'Submit Application', fileTooBig: ' exceeds the 10 MB limit.', fileTooBigGeneric: 'A file exceeds the 10 MB limit.', errorSuffix: ' Please try again or contact us.' },
    es: { submitting: 'Enviando…', submit: 'Enviar solicitud', fileTooBig: ' supera el límite de 10 MB.', fileTooBigGeneric: 'Un archivo supera el límite de 10 MB.', errorSuffix: ' Inténtalo de nuevo o contáctanos.' }
  };
  function applyLang(l) {
    lang = l;
    Array.prototype.forEach.call(root.querySelectorAll('[data-es]'), function (el) {
      var t = el.getAttribute('data-' + l);
      if (t !== null) el.textContent = t;
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-es-ph]'), function (el) {
      var t = el.getAttribute('data-' + l + '-ph');
      if (t !== null) el.placeholder = t;
    });
    if (localeInput) localeInput.value = l;
    langButtons.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-lang') === l); });
    if (submitBtn && !submitBtn.disabled) submitBtn.textContent = I18N[l].submit;
  }
  langButtons.forEach(function (b) {
    b.addEventListener('click', function () { applyLang(b.getAttribute('data-lang')); });
  });

  // Default the signature date to today.
  var dateField = form.querySelector('input[name="signed_date"]');
  if (dateField) dateField.value = new Date().toISOString().slice(0, 10);

  // "I don't have references" toggle (Step 4)
  var noRefsToggleBtn = form.querySelector('[data-toggle-no-refs]');
  var undoNoRefsBtn = form.querySelector('[data-undo-no-refs]');
  var refsWrap = form.querySelector('.acg-df-refs-wrap');
  var noRefsMsg = form.querySelector('.acg-df-no-refs-msg');
  var noRefsFlag = form.querySelector('input[name="no_references"]');
  function setNoRefs(active) {
    if (refsWrap) refsWrap.hidden = active;
    if (noRefsMsg) noRefsMsg.hidden = !active;
    if (noRefsToggleBtn) {
      var row = noRefsToggleBtn.parentElement;
      if (row) row.hidden = active;
    }
    if (refsWrap) {
      Array.prototype.forEach.call(refsWrap.querySelectorAll('input'), function (i) {
        i.disabled = active;
        if (active) i.value = '';
      });
    }
    if (noRefsFlag) noRefsFlag.value = active ? 'true' : '';
  }
  if (noRefsToggleBtn) noRefsToggleBtn.addEventListener('click', function () { setNoRefs(true); });
  if (undoNoRefsBtn) undoNoRefsBtn.addEventListener('click', function () { setNoRefs(false); });

  // "I'll upload these later" button (Step 5)
  var skipDocsBtn = form.querySelector('[data-skip-docs]');
  if (skipDocsBtn) skipDocsBtn.addEventListener('click', function () {
    Array.prototype.forEach.call(form.querySelectorAll('input[type="file"]'), function (f) { f.value = ''; });
    if (nextBtn) nextBtn.click();
  });

  // Marketing channel handle inputs — show when the checkbox is checked
  Array.prototype.forEach.call(form.querySelectorAll('.acg-df-channel'), function (block) {
    var cb = block.querySelector('input[type="checkbox"]');
    var handle = block.querySelector('.acg-df-channel-handle');
    if (!cb || !handle) return;
    cb.addEventListener('change', function () {
      handle.hidden = !cb.checked;
      if (!cb.checked) handle.value = '';
      else handle.focus();
    });
  });

  function showStep(i) {
    current = i;
    steps.forEach(function (s, idx) { s.hidden = idx !== i; });
    progress.forEach(function (p, idx) {
      p.classList.toggle('is-active', idx === i);
      p.classList.toggle('is-done', idx < i);
    });
    backBtn.hidden = i === 0;
    nextBtn.hidden = i === steps.length - 1;
    submitBtn.hidden = i !== steps.length - 1;
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function validateStep(i) {
    var fields = steps[i].querySelectorAll('input, select, textarea');
    for (var j = 0; j < fields.length; j++) {
      var f = fields[j];
      if (f.type === 'file') {
        if (f.files[0] && f.files[0].size > MAX_FILE) {
          var lbl = f.closest('[data-label]');
          window.alert(lbl ? lbl.dataset.label + I18N[lang].fileTooBig : I18N[lang].fileTooBigGeneric);
          return false;
        }
        continue;
      }
      if (!f.checkValidity()) { f.reportValidity(); return false; }
    }
    return true;
  }

  function collectPayload() {
    var p = { customer_base: [], marketing_channels: [], marketing_handles: {}, supplier_references: [] };
    Array.prototype.forEach.call(form.querySelectorAll('input, select, textarea'), function (f) {
      if (!f.name || f.type === 'file' || f.name === 'hp') return;
      if (f.type === 'checkbox') {
        if (f.dataset.group === 'customer_base') { if (f.checked) p.customer_base.push(f.value); }
        else if (f.dataset.group === 'marketing_channels') { if (f.checked) p.marketing_channels.push(f.value); }
        else if (f.name === 'consent') { p.consent = f.checked; }
        return;
      }
      if (f.type === 'radio') { if (f.checked) p[f.name] = f.value; return; }
      p[f.name] = f.value.trim();
    });

    // Collect marketing_handles — one entry per checked channel that has a non-empty handle
    Array.prototype.forEach.call(form.querySelectorAll('.acg-df-channel'), function (block) {
      var cb = block.querySelector('input[type="checkbox"]');
      var handle = block.querySelector('.acg-df-channel-handle');
      if (cb && cb.checked && handle && handle.value.trim()) {
        p.marketing_handles[cb.value] = handle.value.trim();
      }
    });
    // Strip the per-channel handle_* fields collected by the generic loop above
    Object.keys(p).forEach(function (k) { if (k.indexOf('handle_') === 0) delete p[k]; });

    // Build supplier_references — skip fully-empty ref blocks
    [1, 2, 3].forEach(function (n) {
      var ref = {
        company: p['ref' + n + '_company'] || '',
        contact: p['ref' + n + '_contact'] || '',
        phone: p['ref' + n + '_phone'] || '',
        email: p['ref' + n + '_email'] || ''
      };
      if (ref.company || ref.contact || ref.phone || ref.email) {
        p.supplier_references.push(ref);
      }
      ['_company', '_contact', '_phone', '_email'].forEach(function (k) { delete p['ref' + n + k]; });
    });
    if (p.no_references === 'true') p.supplier_references = [];
    delete p.no_references;

    p.years_in_business = p.years_in_business ? Number(p.years_in_business) : 0;
    p.sales_reps_count = p.sales_reps_count ? Number(p.sales_reps_count) : null;
    if (p.warehouses_inventory) p.warehouses_inventory = p.warehouses_inventory === 'yes';
    if (p.advertises_online) p.advertises_online = p.advertises_online === 'yes';
    if (typeof p.consent === 'undefined') p.consent = false;
    return p;
  }

  nextBtn.addEventListener('click', function () {
    if (validateStep(current)) showStep(Math.min(current + 1, steps.length - 1));
  });
  backBtn.addEventListener('click', function () {
    showStep(Math.max(current - 1, 0));
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validateStep(current)) return;

    var fd = new FormData();
    fd.append('payload', JSON.stringify(collectPayload()));
    var hp = form.querySelector('input[name="hp"]');
    fd.append('hp', hp ? hp.value : '');
    Array.prototype.forEach.call(form.querySelectorAll('input[type="file"]'), function (f) {
      if (f.files[0]) fd.append(f.name, f.files[0]);
    });

    submitBtn.disabled = true;
    submitBtn.textContent = I18N[lang].submitting;

    fetch(endpoint, { method: 'POST', body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (res.ok && res.body && res.body.ok) {
          form.hidden = true;
          root.querySelector('.acg-df-progress').hidden = true;
          successPanel.hidden = false;
          successPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          throw new Error((res.body && res.body.error) || 'Submission failed');
        }
      })
      .catch(function (err) {
        errorPanel.querySelector('.acg-df-error-msg').textContent =
          err.message + I18N[lang].errorSuffix;
        errorPanel.hidden = false;
        submitBtn.disabled = false;
        submitBtn.textContent = I18N[lang].submit;
      });
  });

  showStep(0);
})();
